export function DetailStat({ label, value }: { label: string; value: string }) {
  return (
    <div className="rounded-lg border border-border bg-card px-3 py-2">
      <p className="text-[10.5px] font-semibold uppercase tracking-wide text-subtle">{label}</p>
      <p className="mt-1 truncate text-[12px] font-medium text-body">{value}</p>
    </div>
  );
}
